import React from 'react';

import CodeMirrorJsonEditor from '@wp-react/components/CodeMirror/CodeMirrorJsonEditor';
import CodeMirrorPreview from '@wp-react/components/CodeMirror/CodeMirrorPreview';

import { useCustomPreviewData } from '../FormContext';

type Props = {
  editable: boolean;
};

export default function DataPreview({ editable }: Props) {
  const [value, setValue] = useCustomPreviewData();

  if (editable) {
    return (
      <CodeMirrorJsonEditor
        defaultValue={value}
        onChange={(v) => setValue(v)}
        sx={{
          '.cm-editor': { height: '100%' },
          '.cm-focused': { outline: 'none' },
          '.cm-gutters': { borderRadius: 0 },
          width: '100%',
          borderRadius: 0,
          border: 0,
        }}
      />
    );
  }
  return (
    <CodeMirrorPreview
      sx={{
        '.cm-editor': { height: '100%' },
        overflow: 'hidden',
        width: '100%',
      }}
      key={value}
      language={'JSON'}
      value={value}
    />
  );
}
